import classNames from "classnames";
import GridIcon from "icons/GridIcon";
import ListIcon from "icons/ListIcon";
import PropTypes from "prop-types";
import { LAYOUT } from "../../../../constant/layout-constant";
import { LINE_PAGES } from "../../../../util/product/product-constants";
import styles from "./product-filter-layout.module.scss";

function ProductFilterLayout(props: any) {
  const {
    value, onChange, pageType,
  } = props;

  if (["MANUFACTURER_PAGE", ...LINE_PAGES].includes(pageType)) {
    return null;
  }

  return (
    <div className={styles.view_switcher_container}>

      <ListIcon
        className={classNames({
          [styles.active_view_switcher]: value === LAYOUT.DETAILED,
        })}
        color={value === LAYOUT.DETAILED ? "#ffffff" : "#888"}
        onClick={() => onChange(LAYOUT.DETAILED)}
      />
      <GridIcon
        className={classNames({
          [styles.active_view_switcher]: value === LAYOUT.COMPACT,
        })}
        color={value === LAYOUT.COMPACT ? "#ffffff" : "#888"}
        onClick={() => onChange(LAYOUT.COMPACT)}
      />

    </div>
  );
}

ProductFilterLayout.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProductFilterLayout;
